module.exports = __webpack_public_path__ + "static/media/congra-title.63502a31.png";